module.exports = __webpack_public_path__ + "static/media/cancelled.7e440388.svg";